/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".thank-you-label[_ngcontent-%COMP%]{background-color:#d9ebf7;color:#098de0}"];
export { styles as styles };
